/**
 * Which catalog fields the lead prefill filled (KTD7). In convert_lead mode a
 * hidden field is still sent when it holds a non-empty value from the lead, so
 * the lead's value is carried into the new patient and plan (R9);
 * buildIntakePayload reads this set as `leadPrefilledKeys`.
 */
import type { FormState } from './newPatientFormRules';

/** Catalog key → the form-state slots its value lives in. */
const KEY_SLOTS: Readonly<Record<string, ReadonlyArray<keyof FormState>>> = {
  first_name: ['firstName', 'lastName'],
  middle_name: ['middleName'],
  maiden_name: ['maidenName'],
  gender: ['gender'],
  birth_date: ['birthDate'],
  cell_phone: ['cellPhone'],
  email: ['email'],
  address: ['address'],
  city: ['city'],
  state: ['state'],
  zip: ['zip'],
  country: ['addressCountry'],
  plan_type: ['planTypeId'],
  facility: ['facilityId'],
  referral_select_1_anchor: ['referralCategoryId'],
  referral_name: ['referralSourceId'],
  doctor: ['doctorId'],
  coordinator: ['coordinatorId'],
  nurse: ['nurseId'],
  ball_park_given: ['revenueOpportunity'],
  ball_park: ['commitmentLevel'],
  timeframe: ['timeframe'],
  notes: ['notes'],
};

function supplied(value: unknown): boolean {
  if (value === null || value === undefined || value === false) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (typeof value === 'number') return Number.isFinite(value) && value !== 0;
  return true;
}

/**
 * Keys whose slots the lead supplied a value for. `snapshot` holds only what
 * the lead prefill set, so a slot left at its initial value is not counted.
 */
export function leadPrefilledKeys(snapshot: Partial<FormState>): Set<string> {
  const keys = new Set<string>();
  for (const [key, slots] of Object.entries(KEY_SLOTS)) {
    if (slots.some((slot) => slot in snapshot && supplied(snapshot[slot]))) keys.add(key);
  }
  return keys;
}
